import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Header } from './shared/horizontal-menu/horizontal-menu.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'homepage';
  header = $localize`Smart-Metering Test Platform`;
  headers: Header[] = [
    {
      headerText: $localize`Smart-Metering Test Platform`,
      path: './smtpf',
    },
    {
      headerText: $localize`Contact`,
      path: './contact',
    },
    {
      headerText: $localize`Imprint`,
      path: './imprint',
    },
  ];

  constructor(private titleService: Title) {
    this.titleService.setTitle($localize`Smart-Metering Test Platform`);
  }
}
